export const serverScheme = "https";
export const serverUrl = 'api.kazlicrewards.com';
// export const serverScheme = "http";
// export const serverUrl = 'localhost:8080';

export const serverPort = null;
export const serverHttpLinkString = `${serverScheme}://${serverUrl}`;
export const twitchAuthLink = `${serverScheme}://${serverUrl}/auth/twitch`;
export const discordAuthLink = `${serverScheme}://${serverUrl}/auth/discord`;
export const websiteName = `Kazlic Rewards`;
export const kickUsername = `kazlic`;
export const twitterLink = `https://twitter.com/kazlic`;
export const instaLink = `https://www.instagram.com/KazTheDegen`;
export const discordLink = `https://discord.gg/kazlic`;
export const kickLink = `https://kick.com/kazlic`;
export const youtubeLink = `https://www.youtube.com/@Kazlicc`;

/** Post-embed redirect (must be encodeURIComponent’d when used as LuxDrop embed `redirect` query value). */
export const luxdropEmbedRedirectUrl = `https://luxdrop.com?referral=kazlic`;
